import { useRef, useState, type FormEvent } from "react";
import type { Marker, TermBlock, TermDetail } from "@termclear/contracts";
import { api } from "../api";
import { Sheet } from "./Sheet";

export function MarkerSheet(props: {
  term: TermDetail;
  block: TermBlock;
  onClose: () => void;
  onSaved: (marker: Marker) => void;
}) {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const operation = useRef<{ request: string; key: string } | null>(null);
  async function submit(event: FormEvent) {
    event.preventDefault();
    const request = JSON.stringify({
      blockId: props.block.id,
      baselineRevisionId: props.term.currentRevision.id,
      note,
    });
    const currentOperation = operation.current?.request === request
      ? operation.current
      : { request, key: crypto.randomUUID() };
    operation.current = currentOperation;
    setBusy(true);
    setError("");
    try {
      const marker = await api.createMarker(props.term.id, {
        blockId: props.block.id,
        baselineRevisionId: props.term.currentRevision.id,
        note,
      }, currentOperation.key);
      operation.current = null;
      props.onSaved(marker);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "没有保存标记");
    } finally {
      setBusy(false);
    }
  }
  return (
    <Sheet title="标记一下" description="不调用模型，留待以后处理" onClose={props.onClose} className="marker-sheet">
      <form className="sheet-body marker-form" onSubmit={submit}>
        <blockquote className="selected-quote">{props.block.body}</blockquote>
        <label htmlFor="marker-note">我的标记</label>
        <textarea
          id="marker-note"
          rows={5}
          placeholder="记录你的思考、上下文或待办事项…"
          value={note}
          onChange={(event) => setNote(event.target.value)}
          required
        />
        {error ? <p className="form-error" role="alert">{error}</p> : null}
        <div className="dialog-actions">
          <button className="secondary-button" type="button" onClick={props.onClose}>取消</button>
          <button className="primary-button" type="submit" disabled={busy}>{busy ? "保存中…" : "保存标记"}</button>
        </div>
      </form>
    </Sheet>
  );
}
